<h2 mat-dialog-title>New Delivery Order</h2>

<mat-dialog-content [formGroup]="form" class="dialog-body">
  <!-- Customer Info -->
  <div class="section">
    <h3>Customer Information</h3>
    <div class="form-grid">
      <mat-form-field appearance="fill">
        <mat-label>Customer Name</mat-label>
        <input matInput formControlName="customerName" />
      </mat-form-field>

      <mat-form-field appearance="fill">
        <mat-label>Contact Number</mat-label>
        <input matInput formControlName="contactNumber" />
      </mat-form-field>
    </div>
  </div>

  <!-- Driver / Vehicle -->
  <div class="section">
    <h3>Driver Details</h3>
    <div class="form-grid">
      <mat-form-field appearance="fill">
        <mat-label>Select Driver</mat-label>
        <mat-select
          formControlName="driverId"
          (selectionChange)="onRiderSelected($event.value)"
          required
        >
          <mat-option *ngFor="let r of riders" [value]="r.id">
            {{ r.fullName }} — {{ r.phoneNumber }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="fill">
        <mat-label>Vehicle Number</mat-label>
        <input matInput formControlName="vehicleNumber" readonly />
      </mat-form-field>
    </div>
  </div>

  <!-- Pickup -->
  <div class="section">
    <h3>Pickup Point</h3>
    <mat-form-field appearance="fill" class="full-width">
      <mat-label>Pickup Location</mat-label>
      <input matInput formControlName="pickupLocation" />
    </mat-form-field>
  </div>

  <!-- Multiple Deliveries -->
  <div class="section">
    <div class="header-flex">
      <h3>Delivery Destinations</h3>
      <button mat-icon-button color="primary" (click)="addDelivery()" matTooltip="Add Delivery Location">
        <mat-icon>add</mat-icon>
      </button>
    </div>

    <div formArrayName="deliveries">
      <div
        class="delivery-block"
        *ngFor="let delivery of deliveries.controls; let i = index"
        [formGroupName]="i"
      >
        <div class="form-grid">
          <mat-form-field appearance="fill">
            <mat-label>Item</mat-label>
            <input matInput formControlName="item" />
          </mat-form-field>

          <mat-form-field appearance="fill">
            <mat-label>Delivery Location</mat-label>
            <input matInput formControlName="deliveryLocation" />
          </mat-form-field>

          <mat-form-field appearance="fill">
            <mat-label>Receiver Contact</mat-label>
            <input matInput formControlName="receiverContact" />
          </mat-form-field>

          <mat-form-field appearance="fill">
            <mat-label>Notes</mat-label>
            <input matInput formControlName="notes" />
          </mat-form-field>

          <mat-form-field appearance="fill">
            <mat-label>Amount (₦)</mat-label>
            <input matInput type="number" formControlName="amount" />
          </mat-form-field>

          <button
            mat-icon-button
            color="warn"
            (click)="removeDelivery(i)"
            [disabled]="deliveries.length === 1"
            matTooltip="Remove this location"
          >
            <mat-icon>delete</mat-icon>
          </button>
        </div>
      </div>
    </div>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-stroked-button (click)="onCancel()" [disabled]="loading">Cancel</button>
  <button mat-flat-button color="primary" (click)="onSave()" [disabled]="loading">Save</button>
</mat-dialog-actions>
